import React, {Component} from 'react'
import LaddaButton, {SLIDE_UP} from '../LaddaButton'
import Header from '../Header'
import {Link} from 'react-router-dom'
// import * as UrlHelpers from '../helpers/urlHelpers'
import UserOrLogin from '../UserOrLogin'
import AddGym from './AddGym'
import EnsureUser from '../EnsureUser'
// import FontAwesome from 'react-fontawesome'
import Loading from '../Loading'
import _ from 'lodash'

class Gyms extends Component {
  constructor(props) {
    super(props)
    this.state = {
      loading: false,
    }
    this.handleAddGymClick = this.handleAddGymClick.bind(this)
  }

  handleAddGymClick() {
    this.setState({
      isCreating: !this.state.isCreating,
    })
  }

  render() {
    // TODO: come up with better key for holds
    return (
      <div className="container">
        <Header>
          <UserOrLogin />
        </Header>
        {!this.state.isCreating && <h1 className="black">Gyms</h1>}

        {!this.state.isCreating && (
          <div className="thumbnail-group">
            {this.state.loading && <Loading />}
            {this.props.gyms.map(gym => {
              let firstWallKey = _.keys(gym.walls)[0]
              let wallUrl =
                (firstWallKey && gym.walls[firstWallKey].wallUrl) || '/teo0.jpg'
              let iconUrl = gym.iconUrl || wallUrl
              return (
                <Link
                  key={gym.name}
                  className="thumbnail"
                  to={'/gyms/' + gym.id}>
                  <div className="img-wrapper">
                    <img src={iconUrl} alt=""></img>
                  </div>
                  <div>{gym.name}</div>
                </Link>
              )
            })}
          </div>
        )}
        {!(this.state.isCreating || this.state.loading) && (
          <LaddaButton
            onClick={this.handleAddGymClick}
            data-color="mint"
            data-style={SLIDE_UP}
            data-spinner-color="#ddd"
            className={'floating-bottom-right-button'}>
            +
          </LaddaButton>
        )}
        {this.state.isCreating && (
          <EnsureUser>
            <AddGym cancel={this.handleAddGymClick} />
          </EnsureUser>
        )}
      </div>
    )
  }
}

export default Gyms



// WEBPACK FOOTER //
// ./src/components/gyms/Gyms.jsx